import analyticsAPI from '@/api/AnalyticsAPI'

const state = {}

const getters = {}

const actions = {
  setIdentity({ commit }, { id }) {
    analyticsAPI.setIdentity(id)
  },
  startSession() {
    analyticsAPI.startSession()
  },
  endSession() {
    analyticsAPI.endSession()
  },
  logScreen({ commit }, { name, data }) {
    analyticsAPI.logScreen(name, data)
  },
  logEvent({ commit }, { name, data }) {
    analyticsAPI.logEvent(name, data)
  }
}
const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
